/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  RenderTemplateRequestBody,
  RenderTemplateRequestBody$Outbound,
  RenderTemplateRequestBody$outboundSchema,
} from "../components/rendertemplaterequestbody.js";

export type RenderTemplateSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type RenderTemplateSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type RenderTemplateSecurityOption3 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type RenderTemplateSecurity = {
  option1?: RenderTemplateSecurityOption1 | undefined;
  option2?: RenderTemplateSecurityOption2 | undefined;
  option3?: RenderTemplateSecurityOption3 | undefined;
};

export type RenderTemplateRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  renderTemplateRequestBody: RenderTemplateRequestBody;
};

/** @internal */
export type RenderTemplateSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const RenderTemplateSecurityOption1$outboundSchema: z.ZodMiniType<
  RenderTemplateSecurityOption1$Outbound,
  RenderTemplateSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function renderTemplateSecurityOption1ToJSON(
  renderTemplateSecurityOption1: RenderTemplateSecurityOption1,
): string {
  return JSON.stringify(
    RenderTemplateSecurityOption1$outboundSchema.parse(
      renderTemplateSecurityOption1,
    ),
  );
}

/** @internal */
export type RenderTemplateSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const RenderTemplateSecurityOption2$outboundSchema: z.ZodMiniType<
  RenderTemplateSecurityOption2$Outbound,
  RenderTemplateSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function renderTemplateSecurityOption2ToJSON(
  renderTemplateSecurityOption2: RenderTemplateSecurityOption2,
): string {
  return JSON.stringify(
    RenderTemplateSecurityOption2$outboundSchema.parse(
      renderTemplateSecurityOption2,
    ),
  );
}

/** @internal */
export type RenderTemplateSecurityOption3$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const RenderTemplateSecurityOption3$outboundSchema: z.ZodMiniType<
  RenderTemplateSecurityOption3$Outbound,
  RenderTemplateSecurityOption3
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function renderTemplateSecurityOption3ToJSON(
  renderTemplateSecurityOption3: RenderTemplateSecurityOption3,
): string {
  return JSON.stringify(
    RenderTemplateSecurityOption3$outboundSchema.parse(
      renderTemplateSecurityOption3,
    ),
  );
}

/** @internal */
export type RenderTemplateSecurity$Outbound = {
  Option1?: RenderTemplateSecurityOption1$Outbound | undefined;
  Option2?: RenderTemplateSecurityOption2$Outbound | undefined;
  Option3?: RenderTemplateSecurityOption3$Outbound | undefined;
};

/** @internal */
export const RenderTemplateSecurity$outboundSchema: z.ZodMiniType<
  RenderTemplateSecurity$Outbound,
  RenderTemplateSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => RenderTemplateSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => RenderTemplateSecurityOption2$outboundSchema),
    ),
    option3: z.optional(
      z.lazy(() => RenderTemplateSecurityOption3$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
      option3: "Option3",
    });
  }),
);

export function renderTemplateSecurityToJSON(
  renderTemplateSecurity: RenderTemplateSecurity,
): string {
  return JSON.stringify(
    RenderTemplateSecurity$outboundSchema.parse(renderTemplateSecurity),
  );
}

/** @internal */
export type RenderTemplateRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  RenderTemplateRequestBody: RenderTemplateRequestBody$Outbound;
};

/** @internal */
export const RenderTemplateRequest$outboundSchema: z.ZodMiniType<
  RenderTemplateRequest$Outbound,
  RenderTemplateRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    renderTemplateRequestBody: RenderTemplateRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      renderTemplateRequestBody: "RenderTemplateRequestBody",
    });
  }),
);

export function renderTemplateRequestToJSON(
  renderTemplateRequest: RenderTemplateRequest,
): string {
  return JSON.stringify(
    RenderTemplateRequest$outboundSchema.parse(renderTemplateRequest),
  );
}
